import { Injectable } from '@angular/core';
import { AppConstants } from './../constants/app-constants';
import { LoggingService } from './logging/logging.service';


@Injectable()
export class DomStorageFallbackService {
    // tslint:disable-next-line:max-line-length
    public tempSessionObj: any = {};
    public tempSessionObjVal: any = {};
    constructor() { }

    /**
     * @method {hasDomStorageSupport} check Whether the current browser supports local/session storage as a way of storing data
     */

    /* istanbul ignore next */
    public hasDomStorageSupport() {
        try {
            return 'localStorage' in (<any>window) && (<any>window)['localStorage'] !== null || 'sessionStorage' in (<any>window) && (<any>window)['sessionStorage'] !== null;
        } catch (e) {
            if (console && this.readCookie('console') === 'true') {
                console.log(e);
            }
            return false;
        }
    }

    /**
     * @method {readCookie} will read the cookie
     * @param {String} name The name of the property to read from this document's cookies
     * @return {?String} The specified cookie property's value (or null if it has not been set)
     */

    /* istanbul ignore next */
    public readCookie(name) {
        let nameEQ;
        if (name === 'alightSecureSessionToken' || name === 'alightPersonSessionToken') {
            nameEQ = name + '=';
        } else {
            nameEQ = name + '_al' + '=';
        }
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }

        return null;
    }

    /**
     * @method {writeCookie} will write the cookie
     * @param {String} name The name of the property to set by writing to a cookie
     * @param {String} value The value to use when setting the specified property
     * @param {Boolean} isSecure if true, then the cookie should be transferred only over HTTPS.
     * @param {Boolean} isHttpOnly This option forbids any JavaScript access to the cookie. We can't see such cookie or manipulate it using `document.cookie`.
     */

    /* istanbul ignore next */
    public writeCookie(name, value, isSecure = false, isHttpOnly = false) {
        if (console && this.readCookie('console') === 'true') {
            console.log('setItem > writeCookie ::  ', 'name:', name, 'value:', value);
        }
        if (name === 'alightSecureSessionToken' || name === 'alightPersonSessionToken') {
            document.cookie = name + '=' + value + this.expiration() + '; path=/';
        } else {
            // secure : The cookie should be transferred only over HTTPS.
            // httpOnly : This option forbids any JavaScript access to the cookie.
            // We can't see such cookie or manipulate it using document.cookie.
            document.cookie = name + '_al' + '=' + value + this.expiration() + '; path=/' + `${isSecure ? '; secure' : ''}${isHttpOnly ? '; HttpOnly' : ''}`;
        }
    }

    /**
     * @method {expiration} will expire cookies after 12 hours as default
     */

    /* istanbul ignore next */
    public expiration() {
        const date = new Date();
        date.setTime(date.getTime() + (1 * 12 * 60 * 60 * 1000));
        return '; expires=' + date.toUTCString();
    }

    /**
     * @method {deleteCookie} will delete cookies
     * @param {String} name of the cookie
     */

    /* istanbul ignore next */
    public deleteCookie(name) {
        if (name === 'alightSecureSessionToken' || name === 'alightPersonSessionToken') {
            return document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        } else {
            return document.cookie = name + '_al' + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
    }

    /**
     * @method {getMinuteDiff} will get minutes difference of passed values
     * @param {two date values} date values to be passed for compare difference
     */
    /* istanbul ignore next */
    public getMinuteDiff(dt2: any, dt1: any) {
        let diff = (new Date(dt2).getTime() - new Date(dt1).getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    }

    /**
     * @method {setItem} will set the dom storge based on availability
     * @param {String} name The name of the property to set
     * @param {String} value The value to use when setting the specified property
     * @param {String} check the type of dom storage define
     */

    /* istanbul ignore next */
    public setItem(name, value, storageType?: string, isCookieNeeded?: boolean) {

        if (this.hasDomStorageSupport()) {
            if (storageType === 'localStorage') {
                localStorage.setItem(name, value);
                if (console && this.readCookie('console') === 'true') {
                    console.log('setItem > localStorage ::  ', 'name:', name, 'value:', value);
                }
            } else {
                if (console && this.readCookie('console') === 'true') {
                    console.log('setItem > sessionStorage ::  ', 'name:', name, 'value:', value);
                }
                sessionStorage.setItem(name, value);
            }
            if (name === 'alightSecureSessionToken' || name === 'flyoutloadFlag' || name === 'alightPersonSessionToken') {
                localStorage.setItem(name, value);
            }
        } else {
            this.domFallbackStorageObj(name, value, isCookieNeeded);
        }
    }

    /**
     * @method {getItem} will get the dom storge based on availability
     * @param {String} name The name of the value to retrieve
     * @return {String} type of the dom storage
     * @param {Boolean} boolean value if cookie needed
     */

    /* istanbul ignore next */
    public getItem(name, storageType?: string, isCookieNeeded?: boolean) {

        if (this.hasDomStorageSupport()) {
            if (storageType === 'localStorage') {

                if (console && this.readCookie('console') === 'true') {
                    console.log('getItem > localStorage :: ', 'name:', name, ' value', localStorage.getItem(name), ' storageType:', storageType);
                }
                // return localStorage.getItem(name);
                // Added for PCA-6674  // Supporting alightPersonSessionToken
                if ((name === AppConstants.APP_SESS_TOKEN_NAME) || (name === AppConstants.APP_PERSON_TOKEN_NAME)) {
                    return this.isValidToken(localStorage.getItem(AppConstants.APP_PERSON_TOKEN_NAME)) ? localStorage.getItem(AppConstants.APP_PERSON_TOKEN_NAME) : localStorage.getItem(AppConstants.APP_SESS_TOKEN_NAME);
                } else {
                    return localStorage.getItem(name);
                }
                // Added for PCA-6674  // Supporting alightPersonSessionToken ends here.
            } else {
                // let returnVal = sessionStorage.getItem(name); Kept for reference purpose only

                let returnVal: any;
                // Added for PCA-6674  // Supporting alightPersonSessionToken
                if ((name === AppConstants.APP_SESS_TOKEN_NAME) || (name === AppConstants.APP_PERSON_TOKEN_NAME)) {
                    returnVal = this.isValidToken(sessionStorage.getItem(AppConstants.APP_PERSON_TOKEN_NAME)) ? sessionStorage.getItem(AppConstants.APP_PERSON_TOKEN_NAME) : sessionStorage.getItem(AppConstants.APP_SESS_TOKEN_NAME);
                    if (LoggingService.uConsole) {
                        console.log('DomStorageFallbackService.getItem method  :: In session token get block ', returnVal);
                    }
                } else {
                    returnVal = sessionStorage.getItem(name);
                }

                // Added for PCA-6674  // Supporting alightPersonSessionToken ends here.
                if (console && this.readCookie('console') === 'true') {
                    console.log('getItem > sessionStorage :: ', 'name:', name, ' value: ', returnVal, ' storageType:', storageType);
                }
                if ((name === 'alightSecureSessionToken' || name === 'flyoutloadFlag' || name === 'alightPersonSessionToken') && (returnVal === null || returnVal === 'null')) {
                    if (LoggingService.uConsole) {
                        console.log('DomStorageFallbackService.getItem method  :: flyoutblock ', 'name', name, localStorage.getItem(name));
                    }
                    // returnVal = localStorage.getItem(name); updated mechanism below
                    if (name === 'alightSecureSessionToken' || name === 'alightPersonSessionToken') {
                        // tslint:disable-next-line:max-line-length
                        returnVal = this.isValidToken(localStorage.getItem(AppConstants.APP_PERSON_TOKEN_NAME)) ? localStorage.getItem(AppConstants.APP_PERSON_TOKEN_NAME) : localStorage.getItem(AppConstants.APP_SESS_TOKEN_NAME);
                        if (LoggingService.uConsole) {
                            console.log('DomStorageFallbackService.getItem method  :: in alightSecureSessionToken flyout case  ', returnVal);
                        }
                    } else {
                        returnVal = localStorage.getItem(name);
                    }

                    if (LoggingService.uConsole) {
                        console.log('DomStorageFallbackService.getItem method  :: in returnVal final', returnVal);
                    }
                }
                return returnVal;
            }
        } else {
            if (isCookieNeeded) {
                if (console && this.readCookie('console') === 'true') {
                    console.log('getItem > readCookie :: ', 'name:', name, 'value', this.readCookie(name));
                }
                return this.readCookie(name);
            } else {
                if ((<any>window).domFallbackObj) {
                    if (console && this.readCookie('console') === 'true') {
                        console.log('getItem > domFallbackObj :: ', 'name:', name, ' value', (<any>window).domFallbackObj[name]);
                    }
                    return (<any>window).domFallbackObj[name];
                } else {
                    return '';
                }
            }
        }
    }

    /**
     * @method {removeItem} will remove the items used in dom storge based on availability
     * @param {String} name of the storage type used
     * @param {Boolean} boolean value if cookie is used
     */

    /* istanbul ignore next */
    public removeItem(name, storageType?: string, isCookieNeeded?: boolean) {
        if (this.hasDomStorageSupport()) {
            if (storageType === 'localStorage') {
                localStorage.removeItem(name);
            } else {
                if (name !== 'routeDefinition') {
                    sessionStorage.removeItem(name);
                }
            }
        } else {
            if (isCookieNeeded) {
                this.deleteCookie(name);
            } else {
                this.domFallbackStorageObj(name, '');
            }
        }
    }

    /**
     * @method {domFallbackStorageObj} will set the value in object/cookie based on dom storge availability
     * @param {String} name The name of the property to set
     * @param {String} name The value to use when setting the specified property
     * @param {Boolean} set the flag for cookie if needed
     */

    /* istanbul ignore next */
    public domFallbackStorageObj(name, value, isCookieNeeded?: boolean) {
        if (isCookieNeeded) {
            this.writeCookie(name, value);
        } else {
            if (name !== null && value !== null) {
                if ((<any>window).domFallbackObj) {
                    if (console && this.readCookie('console') === 'true') {
                        console.log('setItem > domFallbackObj :: ', 'name:', name, 'value:', value);
                    }
                    (<any>window).domFallbackObj[name] = value;
                }
            }
        }
    }

    // store required values
    /* istanbul ignore next */
    public storeReqValues() {
        const sessionVals = ['enableDynamicURL', 'serviceClients', 'app_url', 'gatewayUrl', 'activeLifecycle', 'gatewayUrlOverridden'];
        try {
            sessionVals.forEach((item) => {
                if (sessionStorage.getItem(item) !== undefined && sessionStorage.getItem(item) !== null && sessionStorage.getItem(item) !== 'null') {
                    this.tempSessionObjVal[item] = sessionStorage.getItem(item);
                }
            });
            if (LoggingService.uConsole) {
                console.log('sessionStorage : storereqValues() : ', this.tempSessionObjVal);
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('sessionStorage : storereqValues() : error in store session value storeReqValues() : ', error);
            }
        }
    }

    // restore required values
    /* istanbul ignore next */
    public restoreReqValues() {
        const sessionVals = ['enableDynamicURL', 'serviceClients', 'app_url', 'gatewayUrl', 'activeLifecycle', 'gatewayUrlOverridden'];
        try {
            sessionVals.forEach((item) => {
                if (this.tempSessionObjVal.hasOwnProperty(item)) {
                    sessionStorage.setItem(item, this.tempSessionObjVal[item]);
                    if (LoggingService.uConsole) {
                        console.log('sessionStorage : restoreSessionValues() : Item : ', item, this.tempSessionObjVal[item]);
                    }
                }
            });
            if (LoggingService.uConsole) {
                console.log('sessionStorage : restorereqValues() : ', this.tempSessionObjVal);
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('sessionStorage : restorereqValues() : error in store session value restoreReqValues() : ', error);
            }
        }
    }

    // store session values
    /* istanbul ignore next */
    public storeSessionValues() {
        try {
            AppConstants.PRE_AUTH_SESSION_VALUES.forEach((item) => {
                if (sessionStorage.getItem(item) !== undefined && sessionStorage.getItem(item) !== null && sessionStorage.getItem(item) !== 'null') {
                    this.tempSessionObj[item] = sessionStorage.getItem(item);
                }
            });
            if (LoggingService.uConsole) {
                console.log('sessionStorage : storeSessionValues() : PRE_AUTH_SESSION_VALUES : ', AppConstants.PRE_AUTH_SESSION_VALUES);
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('sessionStorage : error in store session value storeSessionValues() : ', error);
            }
        }
    }

    // restore session values
    /* istanbul ignore next */
    public restoreSessionValues() {
        try {
            AppConstants.PRE_AUTH_SESSION_VALUES.forEach((item) => {
                if (this.tempSessionObj.hasOwnProperty(item)) {
                    sessionStorage.setItem(item, this.tempSessionObj[item]);
                }
                if (LoggingService.uConsole) {
                    console.log('sessionStorage : restoreSessionValues() : Item : ', item, this.tempSessionObj[item]);
                }
            });
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('sessionStorage : error in restore session value restoreSessionValues() : ', error);
            }
        }
    }

    /**
     * @method {clear} will delete object/stores
     * @param {String} type of the store as usage
     */

    /* istanbul ignore next */
    public clear(storageType?: string, isCookieNeeded?: boolean, isPreAuthPage?: boolean) {
        if (LoggingService.uConsole) {
            console.log('sessionStorage : DomStorageFallbackService : clear() : isPreAuthPage : ', isPreAuthPage, storageType);
        }
        const orgName = this.getOrgName();
        if (this.hasDomStorageSupport()) {
            if (storageType === 'localStorage') {
                let callIntroOverlay = localStorage.getItem('callIntroOverlay');
                localStorage.clear();
                if (callIntroOverlay) {
                    localStorage.setItem('callIntroOverlay', callIntroOverlay);
                }
                if (LoggingService.uConsole) {
                    console.log('localStorage : clear()');
                }
            } else {
                if (!(sessionStorage.getItem('isLogoffClicked') && sessionStorage.getItem('isLogoffClicked') === 'true')) {
                    if (LoggingService.uConsole) {
                        console.log('sessionStorage.getItem > isLogoffClicked == false, store required values.');
                    }
                    // store session values
                    this.storeSessionValues();
                    this.storeReqValues();
                }
                let routeDefinition = sessionStorage.getItem('routeDefinition');
                let lr_json_data = sessionStorage.getItem('lr_json_data');
                // UFD-1558, UFD-2146
                let enableSwDynamicCache = sessionStorage.getItem('enableSwDynamicCache');
                let swconf = sessionStorage.getItem('swconf');
                let app_url = sessionStorage.getItem('app_url');
                let upnFeedback = sessionStorage.getItem('upnFeedback');
                if (LoggingService.uConsole) {
                    console.log('upnFeedback:-' + upnFeedback);
                }
                if (LoggingService.uConsole) {
                    console.log('routeDefinition before session clear :' + routeDefinition);
                }
                if (isPreAuthPage === true) {
                    console.log('Pre Auth request');
                    sessionStorage.clear();
                    if (LoggingService.uConsole) {
                        console.log('sessionStorage : clear() : isPreAuthPage : ', isPreAuthPage);
                    }
                    if (LoggingService.uConsole) {
                        console.log('inside preauth clear function fired');
                    }
                    this.setItem('routeDefinition', routeDefinition);
                    this.setItem('app_url', app_url);
                    if (LoggingService.uConsole) {
                        console.log('routeDefinition after session clear in preauth :' + sessionStorage.getItem('routeDefinition'));
                    }
                    if (!(sessionStorage.getItem('isLogoffClicked') && sessionStorage.getItem('isLogoffClicked') === 'true')) {
                        if (LoggingService.uConsole) {
                            // tslint:disable-next-line:max-line-length
                            console.log('sessionStorage : clear() : preauth flag = true: restore req values : isLogoffClicked : ', sessionStorage.getItem('isLogoffClicked'));
                        }
                        this.restoreReqValues();
                        // tslint:disable-next-line:max-line-length
                        if ((this.readCookie('sessionCookieTime') && (this.getMinuteDiff(new Date().toISOString(), this.readCookie('sessionCookieTime')) <= Number(this.readCookie('sessionStorageClearTime')))) && (this.readCookie('sessionClientName')) === orgName) {
                            if (LoggingService.uConsole) {
                                console.log('In logoff click false and minute differece less than 2 with same org name (inside preauth check) sessionStorageClearTime :' + this.readCookie('sessionStorageClearTime'));
                            }
                            // restore values
                            this.restoreSessionValues();
                            this.writeCookie('sessionCookieTime', new Date().toISOString());
                        }
                    }

                    // UFD-1558, UFD-2146
                    if (enableSwDynamicCache && enableSwDynamicCache != null) {
                        sessionStorage.setItem('enableSwDynamicCache', enableSwDynamicCache);
                    }
                    if (swconf && swconf != null) {
                        sessionStorage.setItem('swconf', swconf);
                    }
                    if (LoggingService.uConsole) {
                        console.log('upnFeedback value Preauth' + upnFeedback);
                    }
                    if (upnFeedback && upnFeedback != null) {
                        sessionStorage.setItem('upnFeedback', upnFeedback);
                    }
                    return;
                }
                let sessionTokenItem = sessionStorage.getItem('alightPersonSessionToken');
                if (sessionTokenItem && sessionTokenItem !== 'null') {
                    sessionStorage.clear();
                    if (LoggingService.uConsole) {
                        console.log('sessionStorage : outside preAuth in alightPersonSessionToken check > clear function fired');
                        console.log('sessionStorage : clear() : sessionTokenItem : ', sessionTokenItem);
                    }
                    if (sessionTokenItem !== null) {
                        sessionStorage.setItem('alightPersonSessionToken', sessionTokenItem);
                    }
                } else {
                    let personTokenItem = sessionStorage.getItem('alightSecureSessionToken');
                    sessionStorage.clear();
                    if (LoggingService.uConsole) {
                        console.log('sessionStorage : outside preAuth else part alightPersonSessionToken check > clear function fired');
                        console.log('sessionStorage : clear() : sessionTokenItem : ', sessionTokenItem);
                    }
                    if (personTokenItem !== null) {
                        sessionStorage.setItem('alightSecureSessionToken', personTokenItem);
                    }
                }
                if (!(sessionStorage.getItem('isLogoffClicked') && sessionStorage.getItem('isLogoffClicked') === 'true')) {
                    if (LoggingService.uConsole) {
                        // tslint:disable-next-line:max-line-length
                        console.log('sessionStorage : clear() : preauth flag = false : restore req values : isLogoffClicked : ', sessionStorage.getItem('isLogoffClicked'));
                    }
                    this.restoreReqValues();
                    // tslint:disable-next-line:max-line-length
                    if ((this.readCookie('sessionCookieTime') && (this.getMinuteDiff(new Date().toISOString(), this.readCookie('sessionCookieTime')) <= Number(this.readCookie('sessionStorageClearTime')))) && (this.readCookie('sessionClientName')) === orgName) {
                        if (LoggingService.uConsole) {
                            console.log('In logoff click false and minute differece less than 2 with same org name (outside preauth check) :' + this.readCookie('sessionStorageClearTime'));
                        }
                        // restore values
                        this.restoreSessionValues();
                        this.writeCookie('sessionCookieTime', new Date().toISOString());
                    }
                }
                if (routeDefinition && routeDefinition != null) {
                    this.setItem('routeDefinition', routeDefinition);
                }
                if (lr_json_data && lr_json_data != null) {
                    this.setItem('lr_json_data', lr_json_data);
                }
                // UFD-1558, UFD-2146
                if (enableSwDynamicCache && enableSwDynamicCache != null) {
                    sessionStorage.setItem('enableSwDynamicCache', enableSwDynamicCache);
                }
                if (swconf && swconf != null) {
                    sessionStorage.setItem('swconf', swconf);
                }
                if (LoggingService.uConsole) {
                    console.log('upnFeedback value Preauth' + upnFeedback);
                }
                if (upnFeedback && upnFeedback != null) {
                    sessionStorage.setItem('upnFeedback', upnFeedback);
                }
                if (LoggingService.uConsole) {
                    console.log('routeDefinition after session clear :' + sessionStorage.getItem('routeDefinition'));
                    console.log('lr_json_data after session clear :' + sessionStorage.getItem('lr_json_data'));
                }
            }
        } else {
            if (isCookieNeeded) {
                let cookiesArray = (<any>window.document).cookie.split(';');
                for (let i = 0; i < cookiesArray.length; i++) {
                    if (cookiesArray[i].indexOf('_al') !== -1) {
                        let cookieKeyEndPos = cookiesArray[i].indexOf('_al=');
                        let cookieKey = cookiesArray[i].substring(0, cookieKeyEndPos);
                        cookieKey = cookieKey.trim();
                        if (cookieKey !== 'alightSecureSessionToken' && cookieKey !== 'alightPersonSessionToken') {
                            this.deleteCookie(cookieKey);
                        }
                    }
                }
            } else {
                if ((<any>window).domFallbackObj) {
                    Object.getOwnPropertyNames((<any>window).domFallbackObj).forEach(function (prop) {
                        delete (<any>window).domFallbackObj[prop];
                    });
                }
            }
        }
    }

    // get org name
    /* istanbul ignore next */
    public getOrgName() {
        try {
            if (window.location.href.indexOf('/web/') !== -1) {
                if (LoggingService.uConsole) {
                    console.log('domstoragefallback service getOrgName() try block window.location.href.indexOf(/web/)');
                }
                return window.location.href.split('/web/')[1].split('/')[0];
            } else {
                if (this.getItem('lr_json_data') && JSON.parse(this.getItem('lr_json_data')).orgName) {
                    if (LoggingService.uConsole) {
                        // tslint:disable-next-line:max-line-length
                        console.log('domstoragefallback service try In else block of getOrgName() lr_json_data org value :', JSON.parse(this.getItem('lr_json_data')).orgName);
                    }
                    return JSON.parse(this.getItem('lr_json_data')).orgName;
                }
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('Error occurred while getting orgname in domstoragefallbackservice', error);
            }
        }
    }

    // Function for checking app token is valid or not
    /* istanbul ignore next */
    public isValidToken(token: any) {
        if ((token) && (token !== 'null') && (token.trim() !== '') && (token !== '""')) { return true; } else { return false; }
    }

    /**
    * @method {getTokenValue} will get value of passed token name as input argument/
    * @param {String} name The name of the token
    * @return {String} type of the dom storage
    * @param {Boolean} boolean value if cookie needed
    */
    /* istanbul ignore next */
    public getTokenValue(name, storageType?: string, isCookieNeeded?: boolean) {
        if (this.hasDomStorageSupport()) {
            if (storageType === 'localStorage') {
                if (console && this.readCookie('console') === 'true') {
                    console.log('getItem > localStorage :: ', 'name:', name, ' value', localStorage.getItem(name), ' storageType:', storageType);
                }
                return localStorage.getItem(name);
            } else {
                let returnVal = sessionStorage.getItem(name);
                if (console && this.readCookie('console') === 'true') {
                    console.log('getItem > sessionStorage :: ', 'name:', name, ' value: ', returnVal, ' storageType:', storageType);
                }
                if ((name === 'alightSecureSessionToken' || name === 'flyoutloadFlag' || name === 'alightPersonSessionToken') && returnVal === null) {
                    returnVal = localStorage.getItem(name);
                }
                return returnVal;
            }
        } else {
            if (isCookieNeeded) {
                if (console && this.readCookie('console') === 'true') {
                    console.log('getItem > readCookie :: ', 'name:', name, 'value', this.readCookie(name));
                }
                return this.readCookie(name);
            } else {
                if ((<any>window).domFallbackObj) {
                    if (console && this.readCookie('console') === 'true') {
                        console.log('getItem > domFallbackObj :: ', 'name:', name, ' value', (<any>window).domFallbackObj[name]);
                    }
                    return (<any>window).domFallbackObj[name];
                } else {
                    return '';
                }
            }
        }
    }

}
